"use client";

import React, { useEffect, useState } from "react";
import CommonCustomSVG, { CustomSVGProps } from "./CustomSVG";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";

export const CustomSVG: React.FC<CustomSVGProps> = (props) => {
  const { fallback = null } = props;

  const { getIcon } = useGlobalContext();

  const src = "src" in props ? props.src : getIcon(props.iconKey);

  const isSvgString = src?.trimStart().startsWith("<svg");

  const [svgContent, setSvgContent] = useState<string | null>(
    isSvgString ? src : null,
  );
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    if (isSvgString) return;

    let isMounted = true;

    if (!src) {
      setSvgContent(null);
      return;
    }

    const fetchSVG = async () => {
      try {
        const response = await fetch(src);
        if (!response.ok) {
          throw new Error(`Failed to fetch SVG: ${response.statusText}`);
        }
        const text = await response.text();
        if (isMounted) {
          setSvgContent(text);
          setError(false);
        }
      } catch (err) {
        console.error("Error fetching SVG:", err);
        if (isMounted) {
          setError(true);
        }
      }
    };

    fetchSVG();

    return () => {
      isMounted = false;
    };
  }, [src, isSvgString]);

  if (error || !svgContent) {
    return <>{fallback}</>;
  }

  return <CommonCustomSVG {...props} svgContent={svgContent} />;
};

export default CustomSVG;
